<template>
  <div>
    <!-- 商品分类管理 -->
    <el-dialog :title="$t('message.productCategoryManagement')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="888px" center>
      <div class="add">
        <!-- 创建一级类目 -->
        <el-button type="success" @click="createFirstLevelCategory">{{ $t('message.createFirstLevelCategory')
        }}</el-button>
      </div>
      <div class="content">
        <el-tree :data="$parent.classifyOption" node-key="id" default-expand-all :props="{
          children: 'childs',
          label: 'name',
        }" :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span style="display: inline-block; margin-right: 100px">{{
              node.label
            }}</span>
            <span>
              <el-button size="mini" v-if="data.parent_id === 0" type="success"
                @click="createSecondLevelCategory(data)">
                <!--            创建二级类目-->
                {{ $t("message.createSecondLevelCategory") }}
              </el-button>
              <el-button size="mini" type="success" class="primary" @click="() => redactItem(data)">
                <!--            编辑-->
                {{ $t("message.redact") }}
              </el-button>
              <el-button size="mini" style="background: #333333; color: #fff" @click="() => classifyDelete(data)">
                <!--            删除-->
                {{ $t("message.delete") }}
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </el-dialog>
    <!--  新增/编辑分类-->
    <el-dialog :title="isAdd ? '新增分类' : '编辑分类'" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="488px"
      center>
      <div class="row" v-if="!isOne == true">
        <!-- 上级分类 -->
        <div class="label">
          {{ $t('message.TheCigherClassification') }}:
        </div>
        <div class="val">
          <el-cascader :options="classifyOption"
            :props="{ checkStrictly: true, children: 'childs', label: 'name', value: 'id' }" v-model="classifyIds"
            clearable placeholder="选择分类" @change="handleChange" style="width: 100%;">
          </el-cascader>
        </div>
      </div>
      <div class="row">
        <!-- 分类名称 -->
        <div class="label">
          {{ $t('message.classificationyName') }}:
        </div>
        <div class="val">
          <el-input v-model="classifyStoreData.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存-->
        <el-button type="primary" @click="classifyStore" v-if="isAdd">{{
          $t("message.save")
        }}</el-button>
        <!-- 保存-->
        <el-button type="primary" @click="classifyUpdate" v-else>{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    classifyOption: { type: Array }
  },
  data() {
    return {
      dialogVisible: false,
      addDialogVisible: false,
      classifyStoreData: {
        name: '',
        parent_id: '',

      },
      classifyIds: [],
      isOne: false,
      isAdd: true,
    };
  },
  methods: {
    redactItem(data) {
      this.isOne = true
      this.isAdd = false
      this.classifyStoreData = {
        name: data.name,
        parent_id: data.parent_id,
        id: data.id
      }
      this.addDialogVisible = true
      this.classifyIds = []
      if (data.parent_id) {
        this.classifyIds = [data.parent_id]
        this.isOne = false
      }
    },
    // 分类删除
    classifyDelete(data) {
      this.$confirm('确定要删除此分类？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.siteConfiguration.classifyDelete({ id: data.id }).then(res => {
          this.$message.success(res.msg)
          this.$parent.classifyList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 创建一级分类
    createFirstLevelCategory() {
      this.isOne = true
      this.isAdd = true
      this.classifyStoreData = {
        name: '',
        parent_id: 0,
      }
      this.addDialogVisible = true
      this.classifyIds = []
    },
    // 创建二级分类
    createSecondLevelCategory(data) {
      this.isOne = false
      this.isAdd = true
      this.classifyStoreData = {
        name: '',
        parent_id: data.id,
      }
      this.classifyIds = [data.id]
      this.addDialogVisible = true
    },
    // 分类
    handleChange(e) {
      // this.datas.classify_id = e[e.length - 1]
    },
    // 新增
    classifyStore() {
      this.$api.siteConfiguration.classifyStore(this.classifyStoreData).then(res => {
        this.addDialogVisible = false
        this.$parent.classifyList()
      })
    },
    //编辑
    classifyUpdate() {
      this.$api.siteConfiguration.classifyUpdate(this.classifyStoreData).then(res => {
        this.addDialogVisible = false
        this.$parent.classifyList()
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.add {
  margin-bottom: 20px;
  text-align: right;
}

.content {
  margin: 0px 15px;

  max-height: 600px;
  overflow-y: auto;

  .el-tree {
    background: transparent !important;

    /deep/ .el-tree-node__content {
      margin-bottom: 20px;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }

    /deep/.el-tree-node__expand-icon {
      font-size: 20px;
    }
  }

  .label {
    width: 100px;
  }
}

.row {
  display: flex;
  padding: 0 20px;
  margin-bottom: 20px;


  .label {
    width: 120px;
    line-height: 40px;
  }

  .val {
    flex: 1;
  }
}
</style>